import { render } from "./Externalcorrespondence.vue?vue&type=template&id=fd691826"
import script from "./Externalcorrespondence.vue?vue&type=script&lang=js"
export * from "./Externalcorrespondence.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__